import { RouteObject } from "react-router-dom";
import BillDetailView from "./DetailLanding";
export interface BillDetailRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillDetailRoute[];
}
export const billDetailRoutes: BillDetailRoute[] = [
  {
    path: "/bx/bill-detail/:id",
    element: <BillDetailView />,
  },
];
